import { RESET_STATE } from 'store/global/actions';

import { RATE_SHEET_ACTION_TYPE } from '../actions';

const initialState = {};

const rateSheetsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RATE_SHEET_ACTION_TYPE.GET_RATE_SHEETS:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default rateSheetsReducer;
